/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from 'react';
import intl from 'react-intl-universal';

import {formatDuration} from "../../helpers/DateHelper";
import OutageSeverityIndicator from "../isp/OutageSeverityIndicator";


export default class OutageSummary extends React.Component {

    outage() {
        return this.props.outage;
    }

    renderTopDrillList(type) {
        const outage = this.outage();

        if (outage.topDrills === undefined)
            return;

        let filter = outage.topDrills
            .filter(drill => (drill.dimName === type))
            .slice(0, 5);
        if (filter.length === 0) {
            return <span>No impact at {type.toLowerCase()} level</span>;
        }

        return filter.map((drill, index) => this.renderDrillDim(drill, (index === filter.length - 1)));
    }

    renderDrillDim(drill, isLast) {
        if (drill.impact > 35) {
            return (<span><strong className="text-body">{drill.dimValue}</strong>{(!isLast ? ', ' : '')}</span>);
        } else {
            return (<span>{drill.dimValue + (!isLast ? ', ' : '')}</span>);
        }
    }

    render() {
        const outage = this.outage();

        let impactScore = "0";
        let impactClass = "";
        let severity = "";
        switch (outage.severity) {
            case "Minor":
                severity = intl.get('outage_severity_minor')
                impactScore = "20";
                impactClass += "text-body";
                break;
            case "Moderate":
                severity = intl.get('outage_severity_moderate')
                impactScore = "40";
                impactClass += "text-body";
                break;
            case "Considerable":
                severity = intl.get('outage_severity_considerable')
                impactScore = "60";
                impactClass += "text-body";
                break;
            case "Major":
                severity = intl.get('outage_severity_major')
                impactScore = "80";
                impactClass += "text-danger";
                break;
            case "Critical":
                severity = intl.get('outage_severity_critical')
                impactScore = "100";
                impactClass += "text-danger";
                break;
            default:
                severity = ""
                impactScore = 0;
                impactClass += "text-body";
                break;
        }

        let diffMsecs = (outage.endTime - outage.startTime);
        let durationText = '';
        if (outage.active) {
            durationText = intl.get('outage_lasting') + " " + formatDuration(diffMsecs, true);
        } else {
            durationText = intl.get('outage_lasted') + " " + formatDuration(diffMsecs, true);
        }

        return (
            <div>
                <span className={"font-weight-semi-bold mr-2 " + impactClass}>{severity}</span>
                <OutageSeverityIndicator score={impactScore} />
                <div className="text-muted small">
                    {durationText}
                </div>
            </div>
        );
    }
}
